import React, { Component } from 'react';
import { isEqual } from 'lodash';

import MultipleChoiceOptions from './MultipleChoiceOptions';
import Question from './Question';
import { ExtendedTranslatedNameType } from '../../../redux/types';

type PropType = {
  question: ExtendedTranslatedNameType;
  options: ExtendedTranslatedNameType[];
  numCases: number;
  startCase: number;
  onSamplePayloadChanged: (a: string, b: number, c: AnswerType | null) => void;
  answerPayload: {
    answers: AnswerType[];
  };
  renderCustomItem: () => void;
  disabled: boolean;
  incomplete? : boolean;
}

type AnswerType = {
  type: string;
  choices: {
    [key: string]: boolean;
  };
};

export default class MultipleChoice extends Component<PropType> {
  shouldComponentUpdate(nextProps: PropType): boolean {
    const current = this.props.answerPayload;
    return !isEqual(current, nextProps.answerPayload)
    || !isEqual(this.props.incomplete, nextProps.incomplete)
    || !isEqual(this.props.question.highlight, nextProps.question.highlight)
    || !isEqual(this.props.options, nextProps.options)
    || !isEqual(this.props.disabled, nextProps.disabled);
  }

  isChecked = (sampleIndex: number, optionId: string): boolean => (
    this.props.answerPayload
      && this.props.answerPayload.answers[sampleIndex]
        && this.props.answerPayload.answers[sampleIndex].choices[optionId]
  );

  render(): React.ReactNode {
    const {
      question,
      options,
      numCases,
      startCase,
      onSamplePayloadChanged,
      answerPayload,
      renderCustomItem,
      incomplete,
      disabled,
    } = this.props;
    return (
      <form>
        <Question
          question={question.text}
          incomplete={incomplete}
          uuid={question.uuid}
          highlight={question.highlight}
        />
        <MultipleChoiceOptions
          options={options}
          startCase={startCase}
          numCases={numCases}
          onChange={(sampleIndex: number, optionId: string, checked: boolean): void => {
            const existing = answerPayload
              && answerPayload.answers[sampleIndex]
              && answerPayload.answers[sampleIndex].choices;
            const choices = { ...existing, [optionId]: checked };
            onSamplePayloadChanged(
              question.uuid,
              sampleIndex,
              { type: 'MultipleChoice', choices },
            );
          }}
          isChecked={this.isChecked}
          renderCustomItem={renderCustomItem}
          disabled={disabled}
        />
      </form>
    );
  }
}
